<div class="container">
  <div class="icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="172"
      height="183"
      fill="none"
    >
      <rect width="135" height="183" x="18" fill="#E2E4E7" rx="8" />
      <path
        stroke="#D26489"
        d="M56.176 151.956v16.214c0 1.892-1.417 4.108-3.363 4.324-1.946.217-17.356.451-26.094 1.081-.36 0-1.135-.216-1.35-1.081-.217-.864-.091-1.621 0-2.432-.181-.18 1.15-1.084 2.582-1.621 2.162-.811 4.443-1.081 6.335-1.352v-15.133M59.84 151.956v16.214c0 1.892 1.416 4.108 3.362 4.324 1.945.217 17.356.451 26.094 1.081.36 0 1.134-.216 1.35-1.081.217-.864.09-1.621 0-2.432.182-.18-1.15-1.084-2.582-1.621-2.162-.811-4.444-1.081-6.335-1.352v-15.133"
      />
      <path
        fill="#2B5799"
        d="M81.85 71h-49.2c-9.872 0-17.874 7.674-17.874 17.14v47.178c0 9.466 8.002 17.139 17.874 17.139h49.2c9.872 0 17.874-7.673 17.874-17.139V88.139C99.724 78.674 91.722 71 81.85 71Z"
      />
      <path
        fill="#fff"
        d="M50.98 98.928h-6.078a3.361 3.361 0 0 0-3.362 3.361v6.078a3.362 3.362 0 0 0 3.361 3.362h6.078a3.361 3.361 0 0 0 3.362-3.362v-6.078a3.361 3.361 0 0 0-3.362-3.36ZM82.399 96.6H76.32c-1.857 0-3.362 1.448-3.362 3.233v6.336c0 1.785 1.505 3.232 3.362 3.232h6.078c1.856 0 3.36-1.447 3.36-3.232v-6.336c0-1.785-1.504-3.232-3.36-3.232Z"
      />
      <path
        stroke="#4B75B4"
        d="M79.58 90.391c-6.987 0-12.651 5.664-12.651 12.651s5.664 12.65 12.65 12.65c6.987 0 12.651-5.663 12.651-12.65s-5.664-12.65-12.65-12.65ZM47.15 93.094c-6.986 0-12.65 5.664-12.65 12.65 0 6.987 5.663 12.651 12.65 12.651s12.65-5.664 12.65-12.651c0-6.986-5.663-12.65-12.65-12.65Z"
      />
      <path
        stroke="#4B75B4"
        d="M59.581 105.744c1.352-1.441 5.46-3.729 7.837-1.351"
      />
      <path
        stroke="#2B5799"
        d="M98.56 109.401c9.502-2.467 18.594-15.484 11.338-25.6M17.685 115.802c-12.8-.582-19.248 14.45-16.291 20.364"
      />
      <path
        fill="#E46393"
        d="M121.537 115.22h34.995a8.279 8.279 0 0 1 8.279 8.279v34.995a8.28 8.28 0 0 1-8.279 8.279h-34.995a8.28 8.28 0 0 1-8.279-8.279v-34.995a8.279 8.279 0 0 1 8.279-8.279Z"
      />
      <path
        fill="#fff"
        d="M122.233 133.193h2.366c.653 0 1.182.529 1.182 1.182v5.914c0 .653-.529 1.183-1.182 1.183h-2.366c-.653 0-1.182-.53-1.182-1.183v-5.914c0-.653.529-1.182 1.182-1.182ZM136.426 132.01h2.365c.653 0 1.183.529 1.183 1.183v5.913c0 .653-.53 1.183-1.183 1.183h-2.365c-.653 0-1.183-.53-1.183-1.183v-5.913c0-.654.53-1.183 1.183-1.183Z"
      />
      <path
        stroke="#2B5799"
        d="M140.283 166.773v9.914c0 1.157.867 2.511 2.056 2.643 1.19.133 10.612.276 15.955.662.22 0 .693-.133.826-.662.132-.528.055-.991 0-1.486.11-.11-.704-.664-1.579-.991-1.322-.497-2.717-.662-3.873-.827v-9.253M138.043 166.773v9.914c0 1.157-.866 2.511-2.056 2.643-1.19.133-10.613.276-15.955.662a.862.862 0 0 1-.825-.662c-.133-.528-.056-.991 0-1.486-.11-.11.703-.664 1.578-.991 1.323-.497 2.717-.662 3.874-.827v-9.253"
      />
      <path
        stroke="#E46393"
        d="M113.981 149.751c-4.846 1.322-8.306-6.239-7.715-11.561m57.954 11.561c4.703-.592 6.505-5.323 7.096-10.645"
      />
      <path
        fill="#FFF7F0"
        fill-rule="evenodd"
        d="M92.728 12C87.355 12 83 16.42 83 21.871V40.49c0 .14.003.279.008.417-.028 7.5.022 14.017.035 15.739l.003.436c0 .626.706 2.191 2.119 1.878 2.326-.516 6.067-5.505 7.85-8.599h27.257c5.373 0 9.728-4.419 9.728-9.87V21.87c0-5.451-4.355-9.871-9.728-9.871H92.728Z"
        clip-rule="evenodd"
      />
      <path
        fill="#2A5595"
        d="M106.5 31.88a4.08 4.08 0 0 0 3.769-2.512 4.088 4.088 0 0 0-.867-4.445 4.084 4.084 0 0 0-6.689 4.408 4.068 4.068 0 0 0 2.213 2.236 4.08 4.08 0 0 0 1.574.313Zm2.046 2.046h-4.125a6.127 6.127 0 0 0-6.13 6.13h16.385a6.128 6.128 0 0 0-6.13-6.13ZM97.804 29.8a3.432 3.432 0 1 0-3.424-3.423 3.424 3.424 0 0 0 3.424 3.424Z"
      />
      <path
        fill="#2A5595"
        d="M103.25 33.15a5.157 5.157 0 0 0-3.73-1.65h-3.423a5.148 5.148 0 0 0-5.148 5.148h7.301a7.073 7.073 0 0 1 5-3.498ZM115.195 29.8a3.43 3.43 0 0 0 3.366-4.104 3.43 3.43 0 0 0-4.685-2.496 3.43 3.43 0 0 0-2.113 3.177 3.417 3.417 0 0 0 1.006 2.424 3.419 3.419 0 0 0 2.426 1ZM114.75 36.664h7.335a5.149 5.149 0 0 0-5.181-5.164h-3.424a5.148 5.148 0 0 0-3.729 1.65 7.07 7.07 0 0 1 4.999 3.514Z"
      />
    </svg>
  </div>
  <seds-modal>
    <div content>
      <div class="content">
        <p class="titulo">Temos novidades!</p>
        <p>
          Apresentamos para você o Portal de logons.<br />
          Uma ferramenta que facilitará a gestão dos usuários de sua empresa.
        </p>
        <p>Veja como ele pode tornar essa gestão mais simples e eficiente.</p>
      </div>
    </div>
    <div class="footer" footer>
      <a mat-dialog-close class="link" (click)="close()">Pular tour</a>
      <seds-basic-button
        mat-dialog-close
        title="Iniciar tour"
        (click)="startTour()"
      ></seds-basic-button>
    </div>
  </seds-modal>
</div>
